import { LuckyNumberInput } from 'common-components'

const Component = (props) => <LuckyNumberInput {...props} />

function EncComponent(props) {
  const { setValue } = props

  const onChange = (newValue) => {
    setValue(newValue)
  };

  return <Component {...props} onChange={onChange} />
}
export default (hoc) => EncComponent
